import { render, staticRenderFns } from "./customer-class-controller.vue?vue&type=template&id=aa1f8c10&scoped=true&"
import script from "./customer-class-controller.vue?vue&type=script&lang=js&"
export * from "./customer-class-controller.vue?vue&type=script&lang=js&"
import style0 from "./customer-class-controller.vue?vue&type=style&index=0&id=aa1f8c10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1f8c10",
  null
  
)

export default component.exports